import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ViAlertType } from '@vi-iot/ui';

import { HorizontalFxLayoutAlign, VerticalFxLayoutAlign } from '../../models/flex-layout.model';

@Component({
  selector: 'vi-alert',
  templateUrl: 'alert.component.html',
  styleUrls: ['alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViAlertComponent {
  @Input() icon = 'error_outline';
  @Input() type: ViAlertType = 'warning';
  @Input() horizontalFxLayoutAlign: HorizontalFxLayoutAlign = 'start';
  @Input() verticalFxLayoutAlign: VerticalFxLayoutAlign = 'start';
}
